export default __webpack_public_path__ + "static/media/movieDb.93596def.jpeg";